<template>
   <section>
      <div v-if="dpp.description" class="grid xs-grid-cols-1 dpp-desc">
         <h2 class="f4 text-bold singleline">{{molang('dpp.desc.activeDppDescription', {streetAddress: dpp.geo?.address})}}</h2>
         <mvtAttribute v-if="getAllPills && getAllPills.length" :data="getAllPills">
         </mvtAttribute>
         <div class="dpp-desc-content" v-if="!dpp.hidePublicRemark" v-html="dpp.description"></div>
         <a v-if="dpp.isPrOnly" class="link" @click.stop="favoriteAction">
            <i v-if="isFavorite" class="icon-heart text-front"></i>
            <span v-if="!isFavorite">{{molang('dpp.getHomeUpdates')}}</span>
            <span v-else>{{molang('dpp.homeSaveProfile')}}</span>
         </a>
      </div>
   </section>
</template>
<script src="./property-desc.js"></script>
